import React from 'react'
import Tooltip from 'rc-tooltip'
import styled from 'styled-components'
import { UserRole, UserEmail } from '@feedyou-ai/feedbot-schema'

import { UserState } from './UserState'
import { UserImage } from '../../UserImage'
import { getTooltipText } from './UserService'

interface Props {
  isFirst: boolean
  isLast: boolean
  id?: string
  name?: string
  email?: UserEmail
  picture?: string
  connected?: boolean
  role?: 'guest' | UserRole | 'admin'
  isEditing: boolean
}

export const User: React.FC<Props> = ({
  id,
  name,
  email,
  picture,
  role,
  connected,
  isFirst,
  isLast,
  isEditing
}) => {
  const imageSize = isLast ? 40 : isEditing ? 30 : 34

  return (
    <Tooltip
      mouseEnterDelay={0.3}
      placement="bottom"
      overlayClassName="user-profile-tooltip-overlay"
      overlay={<span>{getTooltipText(name, role, email, isEditing, connected)}</span>}
    >
      <Wrapper $isFirst={isFirst}>
        <UserImage
          style={{ width: `${imageSize}px`, height: `${imageSize}px` }}
          url={picture}
          name={name}
          isEditing={isEditing}
        />
        {connected !== undefined && <UserState connected={connected} />}
      </Wrapper>
    </Tooltip>
  )
}

interface WrapperProps {
  $isFirst: boolean
}

const Wrapper = styled.div<WrapperProps>`
  position: relative;
  margin-left: ${({ $isFirst }) => ($isFirst ? '0' : '-12px')};
`
